import { CircleLoader, ConfirmationModal } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { CreateExpenseReportForm } from '@webapp/modules/expense/components/CreateExpenseReportForm'
import { ExpenseFormReimbursementCustomizations } from '@webapp/modules/expense/entities/enums/ExpenseFormReimbursementCustomizationEnum'
import messages from './messages'
import { useExpenseRequestView } from './useExpenseRequestView'

export const ExpenseRequestView = () => {
  const intl = useProcurifyIntl()

  const {
    data: {
      initialValues,
      isDraft,
      formData,
      formKey,
      approverOptions,
      isBudgetConfirmOpen,
      baseCurrency,
      mileageLockSetting,
      mileageConfiguration,
    },
    states: { isFormDataLoading, isApproverLoading, isLoading, userId },
    methods: {
      onDepartmentChange,
      onItemsChange,
      onSaveDraft,
      onFormSubmit,
      onReset,
      onConfirmOverBudget,
      onDismissBudgetConfirm,
    },
    refs: { formikRef },
  } = useExpenseRequestView()

  if (isFormDataLoading || userId === undefined) {
    return <CircleLoader />
  }

  return (
    <>
      <CreateExpenseReportForm
        key={formKey}
        initialValues={initialValues}
        userId={userId}
        isDraft={isDraft}
        reimbursementSetting={
          formData?.reimbursementSetting ??
          ExpenseFormReimbursementCustomizations.DEFAULT_YES
        }
        approverOptions={approverOptions}
        isApproverLoading={isApproverLoading}
        isLoading={isLoading}
        formRef={formikRef}
        onSubmit={onFormSubmit}
        onSaveDraft={onSaveDraft}
        onReset={onReset}
        onDepartmentChange={onDepartmentChange}
        onItemsChange={onItemsChange}
        baseCurrency={baseCurrency}
        mileageLockSetting={mileageLockSetting}
        mileageConfiguration={mileageConfiguration}
      />

      <ConfirmationModal
        open={isBudgetConfirmOpen}
        onConfirm={onConfirmOverBudget}
        handleDismiss={onDismissBudgetConfirm}
        header={intl.formatMessage(messages.overBudgetConfirmHeader)}
        content={intl.formatMessage(messages.overBudgetConfirmMessage)}
        confirmButtonText={intl.formatMessage(messages.overBudgetConfirmButton)}
        cancelButtonText={intl.formatMessage(messages.overBudgetCancelButton)}
        type='warning'
      />
    </>
  )
}

ExpenseRequestView.displayName = 'ExpenseRequestView'
